import { render, staticRenderFns } from "./ConnectTeya.vue?vue&type=template&id=79af87d5"
import script from "./ConnectTeya.vue?vue&type=script&lang=js"
export * from "./ConnectTeya.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports